/* Main Menu */
var $ = jQuery.noConflict();

$(function(){
    $(document).ready(function() {
        ////////////////////////////////////////////////
        // START - hide nav on scroll down and show on scroll up
        $(function(){
            var lastScrollTop = 0, delta = 5;
            $(window).scroll(function(){
                var nowScrollTop = $(this).scrollTop();
                
				// Condition to prevent undesired behaviour due to Safari's bounce effect.
                if (nowScrollTop <= 0) {
                    $('.header').removeClass('header-hide');
                    $('.header').addClass('header-show');
                    $('html,body').removeClass('header-hide');
                    $('html,body').addClass('header-show');
                    return; // Exit the function.
                }
                
                if(Math.abs(lastScrollTop - nowScrollTop) >= delta){
                    if (nowScrollTop > lastScrollTop){
                        $('.header').addClass('header-hide');
                        $('.header').removeClass('header-show');
                        $('html,body').addClass('header-hide');
                        $('html,body').removeClass('header-show');
                    } else {
                        $('.header').removeClass('header-hide');
                        $('.header').addClass('header-show');
                        $('html,body').removeClass('header-hide');
                        $('html,body').addClass('header-show');
                    }
                    lastScrollTop = nowScrollTop;
                }
            });
        });
        // END - detect scroll up and down for nav
        ///////////////////////////////////////////////

        ///////////////////////////////////////////////////////////////
        // START - add class to show user is scrolling
        $(window).scroll(function(){
            if ($(window).scrollTop() > 82){
                $('html,body').addClass('is-scrolling');
            } else {
                $('html,body').removeClass('is-scrolling');
            }
        });
        // END - add class to show user is scrolling
        ///////////////////////////////////////////////////////////////

		//// GEOLOCATION
		jQuery('.site-search__loc').on('click', function(){
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(getPostcode);
			} else {
				console.log("Geolocation is not supported by this browser.");
			}
		});

		function getPostcode(position) {
			if (position.coords.latitude && position.coords.longitude) {
				jQuery.ajax({
					url: custom_vars.ajax_url, // Here goes our WordPress AJAX endpoint.
					type: 'POST',
					data: {
						action: 'get_postcode',
						nonce: custom_vars.ajax_nonce,
						lat: position.coords.latitude,
						lng: position.coords.longitude,
					},

					success: function (response) {
						if ( response.success && response.data ) {
							jQuery('#post-search-input').first().val(response.data).closest('#post-search').submit();
						} else {
							console.log("something went wrong.");
						}
					}
				});
			}
		}
    });
});

"use strict";


////////////////////////////////////////////////
// START - remove load class from body
$(window).on('load', function() {
    // When the page has loaded
    $('body').removeClass('page-loading');
});
// END - only show focus ring on tab not click
///////////////////////////////////////////////

////////////////////////////////////////////////
// START - only show focus ring on tab not click
function handleFirstTab(e) {
    if (e.keyCode === 9) {
        document.body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', handleFirstTab);
        window.addEventListener('mousedown', handleMouseDownOnce);
    }
}

function handleMouseDownOnce() {
    document.body.classList.remove('user-is-tabbing');
    window.removeEventListener('mousedown', handleMouseDownOnce);
    window.addEventListener('keydown', handleFirstTab);
}

window.addEventListener('keydown', handleFirstTab);
// END - only show focus ring on tab not click
///////////////////////////////////////////////

function postcodeSearchSubmit(event) {
	event.preventDefault();

	// Get the postcode input field and error span for the submitted form
	var form = event.target;
	var postcodeInput = form.querySelector('.postcode-input');
	var postcodeValue = postcodeInput.value;
	var postcodeError = form.querySelector('.postcode-error');

	// Validate the postcode
	jQuery.ajax({
		url: custom_vars.ajax_url, // Here goes our WordPress AJAX endpoint.
		type: 'POST',
		data: {
			action: 'valid_postcode',
			nonce: custom_vars.ajax_nonce,
			postcode: postcodeValue,
		},

		success: function (response) {
			if (response.success && response.data) {
				postcodeError.classList.add('d-none');
				form.submit();
			} else {
				postcodeError.classList.remove('d-none');
			}
		}
	});
}

// Get all postcode search forms.
var postcodeforms = document.querySelectorAll('.postcode-search');

if (postcodeforms) {
	postcodeforms.forEach(function (form) {
		form.addEventListener('submit', postcodeSearchSubmit);
	});
}


// Function to validate the currency format
function isValidCurrencyFormat(value) {
	// Use a regular expression to check for a valid currency format
	// Here, we are allowing whole numbers (e.g., 24) and decimal numbers (e.g., 24.21)
	const currencyRegex = /^[0-9]+(\.[0-9]{1,2})?$/;
	return currencyRegex.test(value);
}

// Function to validate the input as the user types
function validateCurrencyInput(event) {
	const inputElement = event.target;
	let inputValue = inputElement.value;

	// Use a regular expression to remove any non-numeric characters except for periods
	inputValue = inputValue.replace(/[^0-9.]/g, '');

	// Limit the input to two decimal places
	const decimalParts = inputValue.split('.');
	if (decimalParts.length > 1) {
		// If there are decimal places, limit to two
		inputValue = decimalParts[0] + '.' + decimalParts[1].slice(0, 2);
	}

	// Update the input field with the cleaned numeric value
	inputElement.value = inputValue;
}

// If custom amount entered then remove checked on visible donation amounts.
var customAmount = document.getElementById("other");
var donationAmounts = document.getElementsByName("donation-amount");
var amountRadios = document.querySelectorAll('input[name="donation-amount"]');

if (customAmount && donationAmounts && amountRadios ) {
	// Add an event listener to the custom amount input field to detect changes
	customAmount.addEventListener("input", function (event) {
		validateCurrencyInput(event);

		const inputValue = customAmount.value;

		if (isValidCurrencyFormat(inputValue)) {
			// If the input is in a valid currency format, deselect other donation amounts
			for (var i = 0; i < donationAmounts.length; i++) {
				donationAmounts[i].checked = false;
			}
			document.getElementById("amount-4").checked = true;
		}
	});

	// Add event listeners to the predefined amount radios
	amountRadios.forEach(function (radio) {
		radio.addEventListener('change', function () {
			// Check if a predefined amount radio is selected
			if (radio.checked) {
				// Clear the custom amount input field - commentcomment
				customAmount.value = '';
			}
		});
	});
}

document.addEventListener("DOMContentLoaded", function () {
	// Add a click event listener to all anchor elements on the page
	document.querySelectorAll("a").forEach(function (link) {
		link.addEventListener("click", function (e) {
			// Get the value of the href attribute
			const href = link.getAttribute("href");

			// Check if the href contains "#accordion"
			if (href && href.includes("#accordion-")) {
				// Prevent the default behavior of the anchor link
				e.preventDefault();

				// Extract the data-anchor value from the href
				const dataAnchor = href.substring(1);

				// Find the accordion element with the matching data-anchor attribute
				const accordionElement = document.querySelector(`[data-anchor="${dataAnchor}"]`);

				// Check if the accordion element exists
				if (accordionElement) {
					// Add the "open" class to the accordion element
					accordionElement.classList.add("open");

					// Trigger a click event on the accordion element
					accordionElement.click();
				}
			}
		});
	});
});